import {
  GET_TERMS_CONDITIONS,
  ADD_TERMS_CONDITION,
  DELETE_TERMS_CONDITION,
  UPDATE_TERMS_CONDITION,
  TERMS_CONDITIONS_LOADING,
  GET_AVAILABLE_PROGRAMS,
  GET_TERMS_BY_PROGRAM
} from '../actions/types';

const initialState = {
  termsConditions: [],
  availablePrograms: {
    allPrograms: [],
    availablePrograms: [],
    assignedPrograms: []
  },
  registrationTerms: null,
  termsFetched: false,
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TERMS_CONDITIONS:
      return { 
        ...state, 
        termsConditions: action.payload, 
        loading: false 
      };
    case GET_AVAILABLE_PROGRAMS:
      return {
        ...state,
        availablePrograms: action.payload
      };
    case ADD_TERMS_CONDITION:
      return { 
        ...state, 
        termsConditions: [action.payload, ...state.termsConditions] 
      };
    case UPDATE_TERMS_CONDITION:
      return {
        ...state,
        termsConditions: state.termsConditions.map(tc =>
          tc._id === action.payload._id ? action.payload : tc
        )
      };
    case DELETE_TERMS_CONDITION:
      return {
        ...state,
        termsConditions: state.termsConditions.filter(tc => tc._id !== action.payload)
      };
    case TERMS_CONDITIONS_LOADING:
      return { 
        ...state, 
        loading: true 
      };
    case GET_TERMS_BY_PROGRAM:
      return {
        ...state,
        registrationTerms: action.payload,
        termsFetched: true
      };
    default:
      return state;
  }
}